// extracted by mini-css-extract-plugin
export var circle = "_bj-1";
export var exitConfirmationModal = "_bj-5";
export var iframe = "_bj-0";
export var offline = "_bj-3";
export var online = "_bj-2";
export var workstationSelectError = "_bj-4";